import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { map, Observable } from "rxjs";
import { SvgIcon } from "../../svg-icons.model";

@Component({
  selector: "app-svg-icon-fallback",
  template: `<div [innerHTML]="svg$ | async"></div>`,
  standalone: true,
  imports: [CommonModule],
  styles: `
    :host {
      display: flex;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconFallbackComponent implements OnInit {
  readonly sanitizer = inject(DomSanitizer);
  readonly http = inject(HttpClient);

  @Input({ required: true }) icon: SvgIcon | string = "";

  svg$!: Observable<any>;

  ngOnInit() {
    this.initFallbackSvg();
  }

  initFallbackSvg() {
    this.svg$ = this.http
      .get(`assets/svgs/${this.icon}.svg`, {
        responseType: "text",
      })
      .pipe(
        map((data) => {
          return this.sanitizer.bypassSecurityTrustHtml(data);
        }),
      );
  }
}
